import { Pressable } from '@react-aria/interactions'
import { Text } from 'blaze-ui/Text/Text'
import Styles from './IntegrationHelpButton.module.scss'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'

export const INTERCOM_INTEGRATION_HELP_MESSAGE = 'Hello! Can you help me connect my accounts in Autopilot Onboarding?'

interface IntegrationHelpButtonProps {
  size?: 'sm' | 'md'
  className?: string
  message?: string
  integration?: string
}

export const IntegrationHelpButton = ({ size = 'md', className, message, integration }: IntegrationHelpButtonProps) => {
  const workspace = useCurrentWorkspace()

  const handlePress = () => {
    const helpMessage =
      message ||
      (integration
        ? `Hello! Can you help me connect my ${integration} account? I'm having trouble with the integration setup.`
        : INTERCOM_INTEGRATION_HELP_MESSAGE)
    window.Intercom('showNewMessage', helpMessage)
  }

  if (workspace?.is_ap_freemium) {
    return <></>
  }

  return (
    <div className={className}>
      <Pressable onPress={handlePress}>
        <button className={`${Styles.supportButton} ${Styles[size]}`}>
          <div className={Styles.avatar}>
            <img
              className={Styles.face}
              src="https://res.cloudinary.com/almanac/image/upload/v1756854485/blaze_assets/virtual_marketer/strategies/face_jsgnb8.png"
              alt="Support Avatar"
            />
          </div>
          <Text variant={size === 'sm' ? 'smallList' : 'primary'}>Get Live Help</Text>
        </button>
      </Pressable>
    </div>
  )
}
